import React from 'react';
import moment from "moment";
import html2canvas from "html2canvas";
import toBlob from 'canvas-to-blob';
import axios from "axios"
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
 import { toast } from 'react-toastify';
import { facilityRegisterService, facilitySendOtp, facilityConfirmOtp, emailBaaDoc } from "../../../services/facility/action";
import { patientRegisterService } from "../../../services/patient/action";

import {   showIsLoading,    hideIsLoading } from '../../../services/common/action'


  class PdfPage extends React.Component{
   constructor(props){
     super(props);
     this.state = {
        Approved:false,
        facilityName : "",
        email : "",
        firstName:"",
        lastName:"",
        name :"",
        userType : "",
     }
   }

 

  

componentDidMount(){
    if(this.props.saveRegisteredData){
    let data= this.props.saveRegisteredData 

    let facilityName = data.facilityName;
    let firstName = data.firstName 
    let lastName= data.lastName;
    let email = data.email;
    let name =  data.firstName + " "+ data.lastName;
    let userType = data.userType;
    this.setState({
        facilityName,
        email,
        firstName,
        lastName,
        name,
        userType
    })
}
}

 


facilityRegistration = (e) => {
 
    const input = document.getElementById('divToPrint');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const file = toBlob(imgData);

 
         
        let data= this.props.saveRegisteredData 
        let facilityName = data.facilityName;
        let firstName = data.firstName;
        let lastName = data.lastName;
        let email = data.email;
        let mobile = data.mobile;
        let faxNo = data.faxNo;
        let password = data.password;
        let confirmPassword = data.confirmPassword;
        let address = data.address;
        let address2  = data.address2 ;
        let city = data.city;
        let state = data.state;
        let zip = data.zip;
        let npi = data.npi;
        let officeEmail = data.officeEmail;
        let officePhone = data.officePhone;
        let title = data.title
      
          let payLoad = {
              "userType" : "Facility",
              facilityName,
              firstName,
              lastName,
              email,
              mobile,
              faxNo,
              password,
              confirmPassword,
              address,
              address2 ,
              city,
              state,
              zip,
              npi,
              officeEmail,
              officePhone,
              title,
              "registrationStatus":"pending"
      
          };
      

      
          const formData = new FormData();
          formData.append('facilityInfo', JSON.stringify(payLoad))
          formData.append('scanFile', file)
      
          this.props.facilityRegisterService(formData);

      })
   
    }
    






  componentWillReceiveProps = newProps => {

 
    if(newProps.approve){
        if (newProps.facilityRegisterStatus === true  ) {
            this.setState({
              Approved : false
            },()=>{
                this.props.history.push("/login")
            } )
     } else{    

        this.setState({
            Approved:true
        },()=>{
            if(this.state.Approved){
           
                this.facilityRegistration();
            }
            })
    }
    
    }



 

  

   

}
 
   render(){
   let date = moment().format("MMM Do YYYY"); 
     const {  status } = this.props

    return(
      <React.Fragment>
          {/* <iframe
        title="file"
        style={{ width: '550px', height: '300px' }}
        src={tester}
      /> */}
<div id='divToPrint'  >

<div id="print-area">
        <div className="pdf-page">
            <div className=" title-content text-center">
                <p className="text-title">FERNDALE ROAD, LLC</p>
                <p className="sub-title">BUSINESS ASSOCIATES AGREEMENT FOR USE OF ePaperRoad</p>
            </div>
            <div className="body-content">
                <ol type="I">
                    {/* <!-- section 1 --> */}
                    <li className="sub-title">Definitions</li>
                    <div className="sub-division">
                        <ol type="a">
                            <li><span className="t-under">Catch-all definition</span>: The following terms used in this
                                Agreement shall have
                                the same meaning as those terms in the HIPAA Rules: Breach, Data
                                Aggregation, Designated Record Set, Disclosure, Health Care Operations,
                                Individual, Minimum Necessary, Notice of Privacy Practices, Protected
                                Health Information, Required By Law, Secretary, Security Incident,
                                Subcontractor, Unsecured Protected Health Information, and Use</li>

                            <li><span className="t-under">Specific definitions</span>:
                                <div className="sub-sub-division">
                                    <ol type="i">
                                        <li> <span className="t-under">Business Associate</span>. “Business Associate”
                                            shall generally have the
                                            same meaning as the term “business associate” at 45 CFR 160.103,
                                            and in reference to the party to this agreement, shall mean
                                            Ferndale Road, LLC, its successors, subcontractors and assigns,</li>
                                        <li> <span className="t-under">Covered Entity</span>. “Covered Entity” shall
                                            generally have the same
                                            meaning as the term “covered entity” at 45 CFR 160.103, and in
                                            reference to the party to this agreement, shall mean  
                                            <span className= {status ? "" : "bg-in-color" } >
                                            {status ? this.state.name : " [Insert Name of Doctor’s facility]" }.</span></li>
                                        <li> <span className="t-under">HIPAA Rules</span>. “HIPAA Rules” shall mean the
                                            Privacy, Security,
                                            Breach Notification, and Enforcement Rules at 45 CFR Part 160
                                            and Part 164</li>

                                    </ol>
                                </div>
                            </li>
                        </ol>
                    </div>

                    {/* <!-- Section 2 --> */}


                    <li className="sub-title">Obligations and Activities of Business Associate</li>
                    <div className="sub-division">
                        <ol type="a">


                            <li><span>Business Associate agrees to</span>:
                                <div className="sub-sub-division">
                                    <ol type="i">
                                        <li>
                                            Not use or disclose protected health information other than as
                                            permitted or required by the Agreement or as required by law;
                                        </li>
                                        <li>
                                            Use appropriate safeguards, and comply with Subpart C of 45 CFR
                                            Part 164 with respect to electronic protected health information, to
                                            prevent use or disclosure of protected health information other than
                                            as provided for by the Agreement;
                                        </li>
                                        <li>
                                            Report to covered entity any use or disclosure of protected health
                                            information not provided for by the Agreement of which it becomes
                                            aware, including breaches of unsecured protected health
                                            information as required at 45 CFR 164.410, and any security
                                            incident of which it becomes aware;
                                        </li>
                                        <li>
                                            In accordance with 45 CFR 164.502(e)(1)(ii) and 164.308(b)(2), if
                                            applicable, ensure that any subcontractors that create, receive,
                                            maintain, or transmit protected health information on behalf of the
                                            business associate agree to the same restrictions, conditions, and
                                            requirements that apply to the business associate with respect to
                                            such information;
                                        </li>
                                        <li>
                                            Make available protected health information in a designated record
                                            set to the covered entity as necessary to satisfy covered entity’s
                                            obligations under 45 CFR 164.524;
                                        </li>
                                        
                                        <li className="page-break-before">
                                                Make any amendment(s) to protected health information in a
                                                designated record set as directed or agreed to by the covered entity
                                                pursuant to 45 CFR 164.526, or take other measures as necessary
                                                to satisfy covered entity’s obligations under 45 CFR 164.526;
                                                <div className="sub-sub-division" >
                                                <ol type="1">
                                                    <li>
                                                            Such amendments include a notation that protected health
                                                            information has been extracted and transmitted the
                                                            requesting party.
                                                    </li>
                                                </ol>
                                            </div>
                                        </li>
                                        <li>
                                                Maintain and make available the information required to provide an
                                                accounting of disclosures to the covered entity as necessary to
                                                satisfy covered entity’s obligations under 45 CFR 164.528;
                                        </li>
                                        <li>
                                                To the extent the business associate is to carry out one or more of
                                                covered entity's obligation(s) under Subpart E of 45 CFR Part 164,
                                                comply with the requirements of Subpart E that apply to the
                                                covered entity in the performance of such obligation(s); and
                                        </li>
                                        <li>
                                                Make its internal practices, books, and records available to the
                                                Secretary for purposes of determining compliance with the HIPAA
                                                Rules
                                        </li>
                                
                                    </ol>
                                </div>
                            </li>
                        </ol>
                    </div>

                    {/* <!-- Section 3 --> */}

                    <li className="sub-title">Permitted Uses and Disclosures by Business Associate</li>
                    <div className="sub-division">
                        <ol type="a">
                            

                            <li>
                                <span>Business associate may only use or disclose protected health information</span>:
                                <div className="sub-sub-division">
                                    <ol type="i">
                                        <li> As necessary to perform the services set forth in the “Patient and Third Party Terms of Use”.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <span>Business associate may use or disclose protected health information as
                                    required by law.</span>:
                               
                            </li>
                            <li>
                                <span>Business associate agrees to make uses and disclosures and requests for
                                    protected health information</span>:
                                <div className="sub-sub-division">
                                    <ol type="i">
                                        <li> Consistent with covered entity’s minimum necessary policies and
                                                procedures.</li>
                                    </ol>
                                </div>
                            </li>
                            <li>
                                <span>Business associate may not use or disclose protected health information
                                    in a manner that would violate Subpart E of 45 CFR Part 164 if done by
                                    covered entity except for the specific uses and disclosures set forth below.</span>:
                                <div className="sub-sub-division">
                                    <ol type="i">
                                        <li> Business associate may use protected health information for the
                                                proper management and administration of the business associate
                                                or to carry out the legal responsibilities of the business associate.
                                            </li>
                                    </ol>
                                </div>
                            </li>
                        </ol>
                    </div>

                    {/* <!-- Section 4 --> */}

                    <li className="sub-title">Provisions for Covered Entity to Inform Business Associate of Privacy
                            Practices and Restrictions</li>
                    <div className="sub-division">
                        <ol type="a">
                            

                            <li>
                                <span>Covered entity shall notify business associate of any limitation(s) in the
                                        notice of privacy practices of covered entity under 45 CFR 164.520, to the
                                        extent that such limitation may affect business associate’s use or
                                        disclosure of protected health information</span>
                               
                            </li>
                            <li>
                                <span>Covered entity shall notify business associate of any changes in, or
                                        revocation of, the permission by an individual to use or disclose his or her
                                        protected health information, to the extent that such changes may affect
                                        business associate’s use or disclosure of protected health information.</span>:
                               
                            </li>
                            <li>
                                <span>Covered entity shall notify business associate of any restriction on the use
                                        or disclosure of protected health information that covered entity has
                                        agreed to or is required to abide by under 45 CFR 164.522, to the extent
                                        that such restriction may affect business associate’s use or disclosure of
                                        protected health information.</span>
                             
                            </li>
                        </ol>
                    </div>

                      {/* <!-- Section 5 --> */}

                      <li className="sub-title page-break-before">Permissible Requests by Covered Entity</li>
                    <div className="sub-division">
                        <ol type="a">
                            

                            <li>
                                <span>Covered entity shall notify business associate of any limitation(s) in the
                                        notice of privacy practices of covered entity under 45 CFR 164.520, to the
                                        extent that such limitation may affect business associate’s use or
                                        disclosure of protected health information</span>
                               
                            </li>
                          
                           
                        </ol>
                    </div>

                     {/* <!-- Section 6 --> */}

                     <li className="sub-title">Term and Termination</li>
                     <div className="sub-division">
                         <ol type="a">
                             
 
                                <li>
                                    <span className="t-under">Term</span>: The Term of this Agreement shall be effective as of <span className={status ? "" : "bg-in-color" }>{status ? date : "[todays date]" },</span>
                                    and shall terminate upon the cancellation by either the covered entity or
                                    Ferndale Road, LLC of the covered entity’s ePaperRoad account with
                                    Ferndale Road, LLC or on the date covered entity terminates for cause as
                                    authorized in paragraph (b) of this Section, whichever is sooner.
                                </li>
                                <li>
                                        <span className="t-under">Termination for Cause</span>: Business associate authorizes termination of this
                                        Agreement by covered entity, if covered entity determines business
                                        associate has violated a material term of the Agreement and business
                                        associate has not cured the breach or ended the violation within 10
                                        business days.
                                    </li>
                                    
                            <li>
                                    <span className="t-under">Obligations of Business Associate Upon Termination</span>:
                                    <div className="sub-sub-division">
                                        <ol type="i">
                                            <li> Upon termination of this Agreement for any reason, business
                                                    associate shall destroy all stored or retained protected health
                                                    information received from covered entity, or created, maintained, or
                                                    received by business associate on behalf of covered entity, that the
                                                    business associate still maintains in any form. Business associate
                                                    shall retain no copies of the protected health information.</li>
                                        </ol>
                                    </div>
                                </li>
                                    <li>
                                            <span className="t-under">Survival</span>: The obligations of business associate under this Section shall
                                            survive the termination of this Agreement.
                                        </li>
                           
                            
                         </ol>
                     </div>
                </ol>

                <div className="cover-section">
<p className="text-title-left t-under">Covered Entity</p>
<div className="pdf_sign">
    <p>e-signature</p>

    <div className="pdf-col">
        <p className= {status ? "text-cover-pdf" : "text-cover-pdf bg-in-color" }>{status? this.state.name: "Name of Registered person"}</p>
        <p className="text-cover-title t-under add-width190">Business Associate</p>
        <div className="clear"></div>
    </div>
    <div className="pdf-col sign">
            <div className="d-in-lne"></div>
            <p className="t-top b-top add-width190"><img src="images/sig.png"></img> Kenneth A. Levey</p>
            <div className="clear"></div>
        </div>
        <div className="pdf-col mt-pdf">
                <p className={status ? "text-cover-pdf" : "text-cover-pdf bg-in-color" }>{status ? this.state.facilityName : "Name of Facility"}</p>
                <p className="t-top f-small add-width190">CEO, Ferndale Road, LLC</p>
                <div className="clear"></div>
            </div>
            <div className="pdf-col mt-pdf">
                    <p className={status ? "text-cover-pdf" : "text-cover-pdf bg-in-color" }>Date: <span className= {status ? "" : "bg-in-color" }>{status ? date : "Today’s date" }</span></p>
                    <p className="t-top f-small add-width190">{status ? date : "_________________" }</p>
                    <div className="clear"></div>
                </div>
                <div className="pdf-col mt-pdf">
                        <p className="text-cover-pdf">Business Associate</p>
                        <p className="t-top f-small add-width190">Covered Entity</p>
                        <div className="clear"></div>
                    </div>
</div>

                </div>
            </div>
        </div>
    </div>
    </div>
      </React.Fragment>

    )
   }

 }

 const mapStateToProps = state => ({
    facilityRegisterStatus: state.facilityReducer.facilityRegisterStatus,
    sendBaaDocStatus : state.facilityReducer.sendBaaDocStatus,
    message : state.facilityReducer.message,
    saveRegisteredData : state.facilityReducer.saveRegisteredData,
    PatientRegisterStatus: state.patientReducer.PatientRegisterStatus,

  });

 

const mapDispatchToProps = dispatch => ({
    facilityRegisterService : payLoad => dispatch(facilityRegisterService(payLoad)),
    emailBaaDoc: formData => dispatch(emailBaaDoc(formData)),
});

export default connect(
    mapStateToProps,
  mapDispatchToProps
)(withRouter(PdfPage));